import { render } from "./TotalBonusWithBalance.vue?vue&type=template&id=40fc8810&scoped=true"
import script from "./TotalBonusWithBalance.vue?vue&type=script&lang=js"
export * from "./TotalBonusWithBalance.vue?vue&type=script&lang=js"

import "./TotalBonusWithBalance.vue?vue&type=style&index=0&id=40fc8810&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fc8810"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
